import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

const ReportView = ({ reportId }) => {
  const embedConfig = {
    type: "report",
    id: reportId,
    embedUrl: "https://app.powerbi.com/reportEmbed",
    permissions: models.Permissions.All,
    settings: {
      filterPaneEnabled: true,
      navContentPaneEnabled: true,
    },
  };

  return (
    <PowerBIEmbed
      embedConfig={embedConfig}
      eventHandlers={
        new Map([
          [
            "loaded",
            function () {
              console.log("Report loaded");
            },
          ],
          [
            "rendered",
            function () {
              console.log("Report rendered");
            },
          ],
          [
            "error",
            function (event) {
              console.log(event.detail);
            },
          ],
        ])
      }
      cssClassName={"powerbi-embed-component"}
      getEmbeddedComponent={(embeddedReport) => {
        console.log(embeddedReport);
      }}
    />
  );
};

export default ReportView;
